// extracted by mini-css-extract-plugin
export default {"loaderBackgroundOverlay":"ThreeDotsWithOverlay_loaderBackgroundOverlay__EY2Ns","loaderContainer":"ThreeDotsWithOverlay_loaderContainer__NP4sr"};